var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoreOptions = function SvgMoreOptions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.64 10.32a1.68 1.68 0 1 1 0 3.36 1.68 1.68 0 0 1 0-3.36M12 10.32a1.68 1.68 0 1 1 0 3.36 1.68 1.68 0 0 1 0-3.36M19.36 10.32a1.68 1.68 0 1 1 0 3.36 1.68 1.68 0 0 1 0-3.36"
  })));
};
export default SvgMoreOptions;